module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921084151_T.9bd3465e.jpg";